




























import { Component, Prop, Vue } from 'vue-property-decorator';
import { MomentTransferred } from '@/MomentTransferred'
import * as utils from '@/utils';
import * as utils_time from '@/utils_time';
import * as utils_topshot from '@/utils_topshot';

@Component({
  name: 'MomentTransferredListComponent',
  components: { }
})
export default class MomentTransferredListComponent extends Vue {
  // prop reactive member variables publically available to the html template
  @Prop({ default: null })
  public moment: MomentTransferred

  @Prop({ default: 0 })
  public index: number                 // in case it's ever useful for us to know where we are in the main list

  // public reactive member variables available to the html template

  // public functions available to the html template
  public get loading(): boolean { return this.$store.state.loading }
  public getNicePriceString(number): string { return utils_topshot.getNicePriceString(number)}
  public clickToTopShot() {
    const url: string = this.moment.getTopShotLink(true)
    if (url) window.open(url, "_blank"); 
  }
  public clickedSender(flowAddress: string) {
    if (this.$store.state.devmode) console.log(`clickedSender()`)
    this.$emit('clicked-sender', flowAddress)
  }
  public clickedReceiver(flowAddress: string) {
    if (this.$store.state.devmode) console.log(`clickedReceiver()`)
    this.$emit('clicked-receiver', flowAddress)
  }
  public clickedAvatar(flowAddress: string) {
    const url: string = `/community-tools/account?address=${flowAddress}&mode=activities`
    if (url) window.open(url, "_blank"); 
  }

  // private, non-reactive member variables

  // private functions not available directly to HTML template
  private async mounted() {
    if (this.$store.state.devmode) console.log(`${this.$options.name} mounted()`)
  }

  private async beforeDestroy() { if (this.$store.state.devmode) console.log(`${this.$options.name} beforeDestroy()`) }

}
